var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTajikistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98456 11.3043C0.713155 13.9337 3.05176e-05 16.8835 3.05176e-05 20C3.05176e-05 23.1164 0.713155 26.0662 1.98456 28.6956L20 30.4347L38.0155 28.6956C39.2869 26.0662 40 23.1164 40 20C40 16.8835 39.2869 13.9337 38.0155 11.3043L20 9.56519L1.98456 11.3043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98529 28.6957C5.22021 35.3855 12.0709 40.0001 20.0001 40.0001C27.9292 40.0001 34.78 35.3855 38.0148 28.6957H1.98529Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98529 11.3043H38.0148C34.78 4.61447 27.9292 -6.10352e-05 20.0001 -6.10352e-05C12.0709 -6.10352e-05 5.22021 4.61447 1.98529 11.3043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5218 25.2173H23.4784V22.2607L22.0871 22.9563L20.0001 20.8694L17.9132 22.9563L16.5218 22.2607V25.2173Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5416 21.739L12.8654 22.7354H13.9131L13.0654 23.3513L13.3893 24.3477L12.5416 23.7319L11.694 24.3477L12.0178 23.3513L11.1701 22.7354H12.2178L12.5416 21.739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5455 18.2609L13.8693 19.2573H14.917L14.0693 19.8731L14.3931 20.8695L13.5455 20.2538L12.6978 20.8695L13.0217 19.8731L12.174 19.2573H13.2217L13.5455 18.2609Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4151 15.6521L16.739 16.6485H17.7865L16.939 17.2644L17.2627 18.2608L16.4151 17.645L15.5675 18.2608L15.8913 17.2644L15.0436 16.6485H16.0914L16.4151 15.6521Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4585 21.739L27.1346 22.7354H26.087L26.9346 23.3513L26.6108 24.3477L27.4585 23.7319L28.306 24.3477L27.9823 23.3513L28.8299 22.7354H27.7823L27.4585 21.739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4547 18.2609L26.1309 19.2573H25.0832L25.9309 19.8731L25.6071 20.8695L26.4547 20.2538L27.3024 20.8695L26.9785 19.8731L27.8262 19.2573H26.7785L26.4547 18.2609Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.585 15.6521L23.2612 16.6485H22.2136L23.0611 17.2644L22.7374 18.2608L23.585 17.645L24.4326 18.2608L24.1088 17.2644L24.9564 16.6485H23.9088L23.585 15.6521Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.3477L20.3238 15.3441H21.3715L20.5238 15.9599L20.8476 16.9563L20 16.3405L19.1523 16.9563L19.4761 15.9599L18.6285 15.3441H19.6761L20 14.3477Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/tajikistan.86c02740901e90099cfe445c6ef38c7b.svg";
export { ForwardRef as ReactComponent };